module.exports = __webpack_public_path__ + "static/media/production4.9ce5a706.jpg";